import { Box, Container, Button, Typography } from "@mui/material";
import { Fullscreen } from "@mui/icons-material";
import {
  SCREEN_DAMAGE_TEST_DATA,
  useScreenDamageTestData,
} from "./screenDamageTestData";
import { URL_CONFIG } from "../../config/urlConfig";
import { useLiveDateTime } from "../../utils/liveDateTime";
import AlertBanner from "../../components/AlertBanner";

const ScreenDamageTest = () => {
  const {
    screenRef,
    handleTouchStart,
    handleTouchMove,
    paths,
    goFullscreen,
    showScreenTestScreen,
    hadleOnTouchEnd,
    canvasRef,
    bbpsid,
  } = useScreenDamageTestData();

  const { formattedDateTime } = useLiveDateTime();

  return (
    <>
      {showScreenTestScreen ? (
        <Box
          ref={screenRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={() => {
            hadleOnTouchEnd();
          }}
          sx={{
            position: "relative",
            height: "100vh",
            width: "100vw",
            bgcolor: "white",
            overflow: "hidden",
            touchAction: "none",
          }}
        >
          <Container maxWidth="lg">
            <svg
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
              }}
            >
              {paths.map((path, i) => (
                <polyline
                  key={i}
                  points={path.map((p) => `${p.x},${p.y}`).join(" ")}
                  fill="none"
                  stroke="blue"
                  strokeWidth={URL_CONFIG.STROKE_WIDTH}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              ))}
            </svg>

            {/* Hidden canvas for coverage calculation */}
            <canvas ref={canvasRef} style={{ display: "none" }} />

            {/* Navigation prevention notice */}
            <AlertBanner alertMessage="⚠️ Do not use back button during test" />

            <Box>
              <Typography
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 10,
                  color: "blue",
                  fontSize: "20px",
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <div>{bbpsid}</div>
                <div>{formattedDateTime}</div>
              </Typography>
            </Box>

            {/* <Box
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                zIndex: 10,
                background: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width={90} height={90}>
                <circle
                  cx={45}
                  cy={45}
                  r={34}
                  fill="transparent"
                  stroke="#e3eafc"
                  strokeWidth={5}
                />

                <circle
                  cx={45}
                  cy={45}
                  r={34}
                  fill="none"
                  stroke="#3a5eff"
                  strokeWidth={9}
                  strokeDasharray={2 * Math.PI * 34}
                  strokeDashoffset={2 * Math.PI * 34 * (1 - coverage / 100)}
                  style={{ transition: "stroke-dashoffset 0.5s" }}
                />

                <text
                  x="45"
                  y="50"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize="16"
                  fontWeight="bold"
                  fill={
                    coverage > URL_CONFIG.SCREEN_COVERAGE_THRESHOLD
                      ? "#32CD32"
                      : "#ba8e23"
                  }
                >
                  {`${coverage}%`}
                </text>
              </svg>
            </Box> */}
          </Container>
        </Box>
      ) : (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f7fa",
            flexDirection: "column",
            textAlign: "center",
            px: 2,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#003366",
              fontFamily: "Poppins, 'serif'",
            }}
          >
            {SCREEN_DAMAGE_TEST_DATA.TITLE}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 1,
              color: "#222",
              fontSize: "1.1rem",
              maxWidth: 500,
              fontFamily: "Poppins, 'serif'",
            }}
          >
            {/* English */}
            {SCREEN_DAMAGE_TEST_DATA.INSTRUCTION.ENGLISH}
            {/* Hindi line 1 */}
            <br />
            {SCREEN_DAMAGE_TEST_DATA.INSTRUCTION.HINDI}
          </Typography>

          <Button
            type="button"
            onClick={goFullscreen}
            variant="contained"
            startIcon={<Fullscreen />}
            sx={{
              bgcolor: "#003366",
              color: "#fff",
              px: 4,
              py: 2,
              fontSize: "1.2rem",
              fontWeight: 600,
              borderRadius: 3,
              boxShadow: "0 4px 16px 0 rgba(0,0,0,0.10)",
              textTransform: "none",
              transition: "background 0.2s",
              "&:hover": {
                bgcolor: "#002244",
              },
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            {SCREEN_DAMAGE_TEST_DATA.FULL_SCREEN_BUTTON_TEXT}
          </Button>
        </Box>
      )}
    </>
  );
};

export default ScreenDamageTest;
